/**
 * thumbnailCaptureStore — the manual launcher-thumbnail capture's UI feedback
 * state (ENG-1079). A module singleton (like the other viewport-pill stores),
 * driving <ThumbnailCaptureIndicator/>: the user gets a non-invasive pill for
 * the whole action — "Capturing…" the instant they click, then "saved" (which
 * auto-dismisses) or an error — instead of a bare wait ending in a modal.
 *
 * Only the MANUAL menu action drives this; auto-capture stays silent.
 *
 * phase: 'idle' | 'capturing' | 'saved' | 'error'
 */

let _state = { phase: 'idle', message: '' }
let _listeners = []
let _timer = null

function notify() {
  for (const fn of _listeners) {
    try { fn(_state) } catch (e) { console.warn('[thumbnailCapture]', e) }
  }
}

function set(phase, message, autoDismissMs) {
  if (_timer) { clearTimeout(_timer); _timer = null }
  _state = { phase, message }
  notify()
  if (autoDismissMs && typeof setTimeout === 'function') {
    _timer = setTimeout(() => { _state = { phase: 'idle', message: '' }; _timer = null; notify() }, autoDismissMs)
  }
}

export function getThumbnailCaptureState() { return _state }

export function subscribeThumbnailCapture(fn) {
  _listeners.push(fn)
  return () => { _listeners = _listeners.filter(l => l !== fn) }
}

export const thumbnailCapture = {
  capturing: (message = 'Capturing thumbnail…') => set('capturing', message),
  saved: (message = 'Thumbnail saved') => set('saved', message, 2600),
  error: (message = 'Couldn’t capture thumbnail') => set('error', message, 6000),
  reset: () => set('idle', ''),
}
